export default __webpack_public_path__ + "static/media/Clock_icon.9c12a748.svg";